import { overlayBlueprint } from "@made-people/blueprint-overlay/blueprint";

overlayBlueprint.override({
  slots: {
    overlay:
      "fixed top-0 left-0 size-full bg-black/60 z-[49] opacity-100 transition-opacity",
  },
});
